import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import reducers from "./reducers/index.js";
import sagas from "./sagas";

const initialState = {};

const sagaMiddleware = createSagaMiddleware();

const createStoreWithMiddleware = compose(
  applyMiddleware(
    sagaMiddleware,
  )
)(createStore);

export const store = createStoreWithMiddleware(reducers, initialState);

sagaMiddleware.run(sagas);
